import { render, staticRenderFns } from "./SearchTextfield.vue?vue&type=template&id=52bbb137&scoped=true"
import script from "./SearchTextfield.vue?vue&type=script&lang=js"
export * from "./SearchTextfield.vue?vue&type=script&lang=js"
import style0 from "./SearchTextfield.vue?vue&type=style&index=0&id=52bbb137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bbb137",
  null
  
)

export default component.exports